import { parse } from 'date-fns';
import { SectionA } from 'modules/ESGSentiment/types/esgSentiment';
import { longDateFormat } from 'shared/constants/dateFormat';
import { formatDate } from 'shared/functions';

export const parseSentimentData = (data: SectionA) => {
  const latestChange = parse(data.latestChange, 'dd/MM/yyyy', new Date());
  const history = data.scoreForGraph.slice(0, 3);

  return {
    score: data.esgScore,
    history: {
      labels: history.map(({ date }) => date),
      data: history.map(({ value }) => value),
      labelsMapped: history.map(({ year, date }) => ({ year, date })),
    },
    latestChange: {
      status: {
        UPGRADE: 'Upgrade',
        DOWNGRADE: 'Downgrade',
        STABLE: 'Stable',
      }[data.status],
      date: formatDate(latestChange, longDateFormat),
    },
    levels: {},
    dates: {},
    generalInformation: {},
    documents: [],
  };
};
